import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import ProductServices from "../../../services/Product";
import { ErrorToaster, SuccessToaster } from "../../components/toaster/Toaster";
import ProductForm from "./productform";

const CreateProduct = () => {

  const route = all_routes;
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  // *For Submit Form
  const createProduct = async (formData) => {
    setLoading(true)
    try {
      await ProductServices.createProduct(formData)
      SuccessToaster('Create Successfully')
      navigate(route?.products)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>New Product</h4>
              <h6>Create new product</h6>
            </div>
          </div>
        </div>
        <ProductForm onSubmit={createProduct} loading={loading} />
      </div >
    </div >
  );
};

export default CreateProduct;
